<template>
    <div>

     <v-container>
     		<!-- Form -->
		<v-card>
			<v-card-title>
				<span class="headline">{{ formTitle }}</span>
			</v-card-title>
			<v-form v-model="valid" ref="form" lazy-validation>
				<v-card-text>
					<v-container grid-list-md>
						<v-layout wrap>
							
              <v-flex xs12 sm4 md6>
                <v-select
                label="Procurement Type"
                item-text="name"
                item-value="id"            
                v-model="formSchema.type_id"
                :items="procurement_type_list"
                :rules="[v => !!v || 'Field is required']"
                required
                ></v-select>
              </v-flex>

							<v-flex xs12 sm4 md6>
								 <!-- <v-text-field label="Eco Code" @input="checkEco" v-model="formSchema.eco_head_id" :rules="[v => !!v || 'Field is required']" required></v-text-field> -->
                 <v-autocomplete
                  label="Economic Code"
                  item-text="eco_name_no"
                  item-value="id"
                  :items="eco_head"
                  @change="checkEco($event)"
                  v-model="formSchema.eco_head_id" :rules="[v => !!v || 'Field is required']" required
                ></v-autocomplete>
							</v-flex>

              <v-flex xs12 sm4 md6>
                 <v-text-field label="Economic Code Name" v-model="formSchema.acc_name" disabled></v-text-field>
              </v-flex>

              <!-- <v-flex xs12 sm4 md6>
                 <v-text-field label="Budgeted Amount" v-model="formSchema.budget" disabled></v-text-field>
              </v-flex> -->
              
						</v-layout>
					</v-container>

				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="success"  @click.native="validateBeforeSubmit">{{btnTitle}}</v-btn>
					<v-btn color="error"  @click.native="resetForm" >Reset</v-btn>
				</v-card-actions>
			</v-form>
		</v-card>
		<!-- /Form -->  
     </v-container>
      
    </div>
</template>

<script>
const commonService = require('../../../services/common.service');

import {preFix} from '../../../vuex/api'
import Axios from 'axios'
import serverPath from '../../../server-path/server-path';
export default {
    props:['formSchema'],
    data: () => ({
      valid: true,
      procurement_type_list:[],   
      eco_head:[],       
    }),

    computed: {
      formTitle () {
        return this.formSchema.id > 0 ? 'Update Procurement Type Tag With Economic Code' : 'New Procurement Type Tag With Economic Code'
      },
      btnTitle () {
        return this.formSchema.id > 0 ? 'Update' : 'Save'
      },
    },

    created () {
      commonService.getAllData('proc_get_types').then( res => { 
      
        this.procurement_type_list = res.data;              
      });
      commonService.getAllData('economy-code-info').then( res => { 
      
        this.eco_head = res.data;     
        this.eco_head.forEach((c,i,f)=>{
          c.eco_name_no = c.eco_account_name+' ('+c.eco_account_code+')'
        })       
      });
    },
   
    methods: {
      checkEco(e){
          
        this.eco_head.find(value => {if(value.id == e) { this.formSchema.acc_name = value.eco_account_name}})
      },
      validateBeforeSubmit(e) {
        var formSchema = this.formSchema
        var root = this

        if (this.$refs.form.validate()) {
          if ( formSchema.id > 0 )
          {            
              commonService.updateFormData(this.formSchema, 'proc_type_eco').then(res => {
                let actionData = {
                message: res.message,
                data: res.data,
                action: "edit",
                status: res.status
              };
              this.close(actionData);
						});
          }
          else
          {            
            commonService.insertFormData(this.formSchema, 'proc_type_eco').then(res => {
              let actionData = {
                message: res.message,
                data: res.data,
                action: "add",
                status: res.status
              };
              this.close(actionData);
						});
          }
        }  
      },

      resetForm()
      {
        if (this.formSchema.id > 0) {
        // close(0);
         let actionData = {
                message: "Form Reset",
                data: this.formSchema,
                action: "edit",
                status: 1,
          };
        this.$emit("emitCloseModal", actionData);
        this.$refs.form.reset();
      } else {
        this.$refs.form.reset();
      }
      },

      close(data){
         if(data.status == 1)
         {
           this.$refs.form.reset();
         }  
        this.$emit("emitCloseModal", data);

      },

    },

}
</script>



// WEBPACK FOOTER //
// src/components/procurement/type_eco/ecocodeForm.vue